export { useGetNavigateToTeamsApp } from '../src/useGetNavigateToTeamsApp.ts';
